import { use } from 'react'
import { InternalChangeBaseParametersOverlayContext } from './InternalChangeBaseParametersOverlayContext'

export const useShowChangeBaseParametersInformationOverlay = () => {
  const context = use(InternalChangeBaseParametersOverlayContext)
  return (
    context?.showOverlay ??
    (() => {
      throw new Error('ChangeBaseParametersOverlayContext not found')
    })
  )
}
